<template>
    <div>
        <fluke-card>
            <header>
                <div class="title">Adicionar Usuário</div>
                <div class="description">Insira os dados do usuário</div>
            </header>
            <main>
                <v-text-field label="Usuário" v-model="user"></v-text-field>
                <v-text-field
                    label="Senha"
                    :type="'password'"
                    v-model="password">
                </v-text-field>
            </main>
            <footer>
                <fluke-button v-on:click.native="cancel" color="grey">cancelar</fluke-button>
                <fluke-button v-on:click.native="submit">Salvar</fluke-button>
            </footer>
        </fluke-card>
    </div>
</template>

<script>
import axios from 'axios';

import Card from '../../components/Main/Content/Card/Card.vue';
import Button from '../../components/Main/Content/Button/Button.vue';

import permission from '../../mixins/permissions';


export default {
    mixins: [ permission ],
    components: {
        'fluke-card': Card,
        'fluke-button': Button
    },
    data: function() {
        return {
            user: '',
            password: ''
        }
    },
    methods: {
        submit: async function()
        {
            const result = await axios.post(
				this.$myServerAddresses.admin + 'users',
				{
                    user: this.user,
                    password: this.password
				},
                {
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                }
            );
            this.$router.push({ name: 'users' });
        },
        cancel: function() {
            this.$router.push({ name: 'users' });
        },
    }
}
</script>
